import { render, staticRenderFns } from "./SolicitacaoHistorico.vue?vue&type=template&id=a9103a3e&scoped=true"
import script from "./SolicitacaoHistorico.vue?vue&type=script&lang=js"
export * from "./SolicitacaoHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9103a3e",
  null
  
)

export default component.exports